import React from "react";
import {Section} from "./Section";
import {Card, Typography, Row, Col, Space, Tag} from "antd";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";



export const Establishments = ({data,fetchConfig})=>{
    return <Section
        title={"Establishments"}
        data={data}
        schema={"reg_approval_establishments"}
        fetchConfig={async ()=>{
            return await fetchConfig({schema: "reg_approval_establishments"})
        }}
        resolve={(props)=>{
            switch (props.name){
                case "establishments":
                    return (data.self_reg_establishment || []).map((o,i)=>{
                        return <Card title={`#${i}`} style={{width: 500}}>
                            <tr className={"section-item"} >
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Full Name</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>
                                        {o.name}
                                    </Typography.Text>
                                </td>
                            </tr>
                            <tr className={"section-item"} >
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>VAT ID</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>
                                        {o.vat_number}
                                    </Typography.Text>
                                </td>
                            </tr>
                            <tr className={"section-item"}>
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Address</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Space direction={"vertical"}>
                                        {(o.address|| "").split(",").map(q=><Typography.Text>{q}</Typography.Text>)}
                                    </Space>

                                </td>
                            </tr>
                            <tr className={"section-item"}>
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Country</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>
                                        {resolve({...props, value: o.country_id})}
                                    </Typography.Text>
                                </td>
                            </tr>
                        </Card>
                    });
                default:
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
            }
        }}
    />
}
